export default __webpack_public_path__ + "static/media/FemaleIcon.0746d067.svg";